import axios from "axios";
import { API_URL } from "src/lib/config.helper";

const axiosPublic = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export function setDefaultAuthorizationToken(token: string): void {
  axiosPublic.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export default axiosPublic;
